import styles from "./passwordRules.module.scss";

const PasswordRules = () => {
  return (
    <div className={styles.div}>
      <ul>
        <li>Minimum 8 characteres required.</li>
        <li>At least 1 upper case letter required.</li>
        <li>At least 1 lower case letter required.</li>
        <li>At least 1 number required.</li>
        <li>Cannot have dictionary word.</li>
        <li>Cannot have repetetive characters.</li>
        <li>Cannot have sequential characters.</li>
        <li>Passwords must match.</li>
      </ul>
    </div>
  );
};

export default PasswordRules;
